import { Pipe, PipeTransform } from '@angular/core';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Pipe({
	name: 'filterBeneficiaireByDepartment'
})
export class FilterBeneficiaireByDepartmentPipe implements PipeTransform {
	transform(
		beneficiaires: Beneficiaire[],
		centerDepartments: CenterDepartment[]
	): Beneficiaire[] {
		if (
			beneficiaires === null ||
			!beneficiaires ||
			(Array.isArray(beneficiaires) && beneficiaires.length === 0) ||
			centerDepartments === null ||
			(Array.isArray(centerDepartments) && centerDepartments.length === 0)
		) {
			return beneficiaires;
		}

		return beneficiaires.filter((beneficiaire) => {
			return beneficiaire.centerDepartments.some((spe) =>
				centerDepartments
					.map((spec) => spec.name)
					.some((specStr) => specStr.includes(spe.name))
			);
		});
	}
}
